module.exports = __webpack_public_path__ + "static/img/technologyu03.7909a68d.svg";